import { NEW_API_BASE_URL } from '../env';

const newAPI = (path, params, method, token) => {
  let options;
  options = {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      ...(token && { 'X-AUTH-TOKEN': `${token}` }),
    },
    method: method,
    ...(params && { body: JSON.stringify(params) }),
  };
  //console.log('baseUrl new api', NEW_API_BASE_URL + path, "Params", params, "Opt", options);
  return fetch(NEW_API_BASE_URL + path, options)
    .then(resp => resp)
    .catch(error => error);
};

export default newAPI;
